import React from 'react';
import { useInView } from 'react-intersection-observer';

const stats = [
  { number: '500+', label: 'HAZOP Studies Completed' },
  { number: '98%', label: 'Client Satisfaction Rate' },
  { number: '35%', label: 'Average Time Saved' },
  { number: '50+', label: 'Industry Templates' }
];

export default function Stats() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  return (
    <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-950 text-white">
    {/* // <section className="py-20 text-white"> */}
    {/* <section className="py-20 bg-gradient-to-r from-blue-600 to-indigo-600 text-white"> */}
      <div className="container mx-auto px-4">
        <div 
          ref={ref}
          className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12"
        >
          {stats.map((stat, index) => (
            <div 
              key={index}
              className={`text-center transform transition-all duration-700 ${
                inView 
                  ? 'translate-y-0 opacity-100' 
                  : 'translate-y-10 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="text-4xl md:text-5xl font-bold mb-2 text-white">
                {stat.number}
              </div>
              <div className="text-sm md:text-base">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}